import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SurtitleTagType } from 'src/app/content-management/shared/enums/surtitle-tag-type';
import { ISelectListItem } from '../../interfaces/i-select-list-item';
import { ISurtitle } from 'src/app/core/models/i-surtitle';
import { FormArray, FormControl } from '@angular/forms';
import { SurtitleTypeString } from 'src/app/content-management/shared/enums/surtitle-type-string';

@Component({
  selector: 'app-tag-button',
  templateUrl: './tag-button.component.html',
  styleUrls: ['./tag-button.component.scss'],
})
export class TagButtonComponent {
  @Input() tag!: ISelectListItem;
  @Input() surtitleTagType!: SurtitleTagType;
  @Input() surtitleControl!: FormArray<FormControl<ISurtitle>>;

  @Output() tagSelected = new EventEmitter<any>();

  SurtitleTypeString = SurtitleTypeString;

  onClick() {
    this.tagSelected.emit(this.tag);
  }

  isSelected(tag: ISelectListItem, tagType: SurtitleTagType): boolean {
    const surtitle = this.surtitleControl?.controls[0]?.value;
    if (!surtitle) return false;
    return (
      surtitle.name === tag.displayName &&
      this.getSurtitleTypeString(SurtitleTypeString[surtitle.surtitleType]) ===
        this.getSurtitleTypeString(SurtitleTypeString[tagType])
    );
  }

  getSurtitleTypeString(type: SurtitleTypeString): string {
    if (
      typeof type === 'string' &&
      Object.values(SurtitleTypeString).includes(type)
    ) {
      return type.replace(/([a-z])([A-Z])/g, '$1 $2');
    }
    return 'Unknown';
  }
}
